import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { TrnxCommonTs } from 'src/app/shared/common/trnxCommonTs';
import { constants } from "src/app/shared/common/contants";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { CommonService } from 'src/app/shared/services/common.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { TrnxBasePopupScreenComponent } from '../trnx-base-popup-screen/trnx-base-popup-screen.component';
import { UntypedFormGroup } from "@angular/forms";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { validationmethod } from "src/app/shared/common/validationmethod";
import * as moment from "moment";
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import {NgxUiLoaderService} from 'ngx-ui-loader';

export interface FormData {
  tableName: any;
  tableId: any;
  trnxScreenId: any;
  childKey: any;
  headerNameHtml: any;
  masterTableId: any;
  tMTN: any;
  tMRD: any;
  listObjectDropDown: any;
}

@Component({
    selector: 'app-trnxchild-base-screen',
    templateUrl: './trnxchild-base-screen.component.html',
    styleUrls: ['./trnxchild-base-screen.component.scss'],
    standalone: false
})
export class TrnxchildBaseScreenComponent implements OnInit {

  tableName;
  tableId;
  trnxScreenId;
  childKey;
  gridAPI;
  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnChildDefs;

  rowClassRules;

  defaultChildColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;

  components: any;

  overlayNoRowsTemplate;

  listObjectDropDown: any = [];

  dynamicChildData = [];

  trnxScreenChildId;

  ngModelChildObject = [];

  ngModelChildObjectDivision = [];

  bootstrapChildColumn = 0;

  //dropDowns = [];

  retrieveObject: any = [];

  headerNameHtml = "";

  buttonName;

  childTableID = "";

  agGridChildShow = false;

  retrieveNgModelChildCreation: any = [];

  screenType

  value;

  recordsStart = 0;

  allocateButtonsBoolean = false;

  allocateButtons1Boolean = false;

  masterTableId = "";

  formValid: UntypedFormGroup;

  dynamicData = [];

  ngModelObject = [];

  ngModelObjectDivision = [];

  bootstrapColumn = 0;

  tableID = "";

  agGridShow = false;

  tMTN = "";

  tMRD = {};

  childrenDropDownsIncrement = 0;

  numberOfChildrenDropDowns = 0;

  //tMLOD is TransactionMasterListObjectDropdown.
  tMLOD: any = [];

  //tMLODD is TransactionMasterListObjectDropdownDuplicate.
  tMLODD: any = [];

  hide = false;

  eyeIcon = false;

  backgroundColorButton = "";
  TransactionMasterHeader ="Transaction Master";
  TransactionDetailHeader="Transaction Detail";

  constructor(private dialogref: MatDialogRef<TrnxchildBaseScreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormData, private trnxCommonTs: TrnxCommonTs,  private spinner: NgxUiLoaderService, private snackBar: MatSnackBar,private constants: constants, private service: CommonService, private dialog: MatDialog, private localStorageSettings: LocalStorageSettingsService, private validation: validationmethod, private sanitizer: DomSanitizer) {
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
    }
    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  async ngOnInit() {

    console.log(this.data);

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    this.tableName = this.data.tableName;
    if(this.tableName=="testcycletrxn"){
      this.TransactionMasterHeader="Test Cycle";
      this.TransactionDetailHeader="Test Scripts";
    }

    this.tableId = this.data.tableId;
    this.trnxScreenId = this.data.trnxScreenId;
    this.childKey = this.data.childKey;
    this.headerNameHtml = this.data.headerNameHtml

    if (this.headerNameHtml == "Application Page Library") {
          this.TransactionMasterHeader = "Page and Script Association"
          this.TransactionDetailHeader = "Associated Test Scripts"
    }

    console.log(this.tableName)
    console.log(this.tableId)
    console.log(this.trnxScreenId)
    console.log(this.childKey)

    this.masterTableId = this.data.masterTableId;

    console.log(this.masterTableId);

    this.tMTN = this.data.tMTN;

    this.tMRD = this.data.tMRD;

    console.log(this.tMLOD);

    let retrieveNgModelChildCreation: any = [];

    retrieveNgModelChildCreation = await this.trnxCommonTs.retrieveChildTableData(this.trnxScreenId);

    this.dynamicChildData = retrieveNgModelChildCreation[0];

    console.log(this.dynamicChildData);

    this.trnxScreenChildId = retrieveNgModelChildCreation[6];
    console.log(this.trnxScreenChildId)

    this.ngModelChildObject = retrieveNgModelChildCreation[1];

    console.log(this.ngModelChildObject);

    this.ngModelChildObjectDivision = retrieveNgModelChildCreation[2];

    console.log(this.ngModelChildObjectDivision);

    this.bootstrapChildColumn = retrieveNgModelChildCreation[3];

    console.log(this.bootstrapChildColumn);

    this.childTableID = retrieveNgModelChildCreation[4];

    console.log(this.childTableID);

    this.agGridChildShow = await retrieveNgModelChildCreation[5];

    // array to bind data to ag grid this.validation.equalto("password")
    this.columnChildDefs = [];

    this.columnChildDefs.push({
      headerName: "Action",
      filter: false,
      cellRenderer: "buttonRenderer",
      cellRendererParams: {
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this)
      },
      pinned: 'left',
      lockPinned: true,
      width: 150
    });

    console.log(this.dynamicChildData);

    this.dynamicChildData.forEach(e => {

      if (e.showinGrid) {

        let fieldName = "";

        console.log(e.fieldType);

        console.log(e.fieldType == "valueDropDown");

        //if columntype is valueparentdropdown or valuedropdown then dropdownvalues are storing into columnname
        if (e.fieldType == "valueParentDropDown" || e.fieldType == "valueDropDown" || e.fieldType == "Linked Fields") {

          fieldName = e.dropDownValues;

          console.log(fieldName);

        }
        else if (e.fieldType == "Select List - Static") {

          fieldName = e.fieldName.toString() + 1;

          console.log(fieldName);

        }

        else {

          fieldName = e.fieldName;

          console.log(fieldName);

        }

        this.columnChildDefs.push({
          headerName: e.agGridColumnName,
          headerTooltip: e.agGridColumnName,
          tooltipValueGetter: params => e.agGridColumnName + " : " + params.value,
          field: fieldName,
          filter: "agTextColumnFilter",
          width: 180
        });

      }

    });


    this.columnChildDefs.push({
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'status',
      filter: 'agTextColumnFilter',
      width: 150,
      cellStyle: function (params) {
        if (params.value == 'Yes') {
          return { color: 'green' };
        } else {
          return { color: 'red' };
        }
      }
    });

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultChildColDef = {
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    //await this.retrieve();

    let retrieveNgModelCreation: any = [];

    console.log(this.tMTN);

    retrieveNgModelCreation = await this.trnxCommonTs.ngModelTrnxObjectCreation(this.tMTN);

    this.dynamicData = retrieveNgModelCreation[0];

    console.log(this.dynamicData);

    //this.trnxScreenId = retrieveNgModelCreation[6];
    //console.log(this.trnxScreenId)

    this.ngModelObject = retrieveNgModelCreation[1];

    console.log(this.ngModelObject);

    let ngModelObjectDivisionTemp = retrieveNgModelCreation[2];

    console.log(ngModelObjectDivisionTemp);

    ngModelObjectDivisionTemp.forEach(ngModelObjectDivisionTemporary => {

      if (ngModelObjectDivisionTemporary.length > 0) {

        this.ngModelObjectDivision.push(ngModelObjectDivisionTemporary);

      }

    });

    console.log(this.ngModelObjectDivision);

    this.bootstrapColumn = retrieveNgModelCreation[3];

    console.log(this.bootstrapColumn);

    this.tableID = retrieveNgModelCreation[4];

    console.log(this.tableID);

    this.agGridShow = await retrieveNgModelCreation[5];

    this.ngModelObject = this.trnxCommonTs.trnxEditIcon(this.ngModelObject, this.tMRD);
    console.log(this.ngModelObject)

    this.ngModelObject.forEach(inputObject => {

      if (inputObject.imageName != null && inputObject.keyValue != null) {

        if ((inputObject.keyValue).length > 0) {

          let extension: any;

          if ((inputObject.keyValue).includes(".")) {

            extension = (inputObject.keyValue).substring((inputObject.keyValue).lastIndexOf(".") + 1);

            console.log(extension);

          }

          if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {

            this.binaryFormatImage(inputObject);

          }

        }

      }

    });

    console.log(this.ngModelObject);

    this.data.listObjectDropDown.forEach(listObjectDropDownTemp => {

      let listTemporary: any = [];

      listObjectDropDownTemp.forEach(listObjectDropDownTemporary => {

        listTemporary.push(Object.assign({}, listObjectDropDownTemporary));

      });

      this.tMLOD.push(listTemporary);

      this.tMLODD.push(listTemporary);

    });

    // form validations
    this.formValidations();

  }
  // below function is to load the ag grid
  async onGridChildReady(params) {
    console.log(this.dynamicChildData)
    for (let i = 0; i < this.dynamicChildData.length; i++) {

      if (this.dynamicChildData[i].fieldType == "valueDropDown" || this.dynamicChildData[i].fieldType == "valueParentDropDown" || this.dynamicChildData[i].fieldType == "Linked Fields") {

        console.log(this.dynamicChildData[i].fieldName);

        console.log(this.dynamicChildData[i]);

        /*this.dropDowns.push([this.dynamicData[i].fieldName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);

        console.log(this.dropDowns);*/
        let templistObjectDropDown = "";
        templistObjectDropDown = await this.trnxCommonTs.retrieveTrnxDropDown(this.dynamicChildData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.dynamicChildData[i].dropDownIDs, this.dynamicChildData[i].dropDownValues, this.dynamicChildData[i].lookupTableName);
        console.log(templistObjectDropDown)
        this.listObjectDropDown.push(templistObjectDropDown)
        console.log(this.listObjectDropDown);

      }
      if (this.dynamicChildData[i].fieldType == "Select List - Static") {

        console.log(this.dynamicChildData[i].fieldName);

        console.log(this.dynamicChildData[i]);

        /*this.dropDowns.push([this.dynamicData[i].fieldName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);

        console.log(this.dropDowns);*/
        let templistObjectDropDown = "";
        templistObjectDropDown = await this.trnxCommonTs.retrieveTrnxDropDown(this.dynamicChildData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.dynamicChildData[i].dropDownIDs, this.dynamicChildData[i].dropDownValues, this.dynamicChildData[i].lookupTableName);
        this.listObjectDropDown.push(templistObjectDropDown)
        console.log(this.listObjectDropDown);

      }

    }

    this.gridAPI = params.api;

    this.gridColumnAPI = params.columnApi;

    //api call to get the location data
    this.retrieve();

  }

  // Aggrid Edit function
  editIcon(e) {

    if (e.rowData.status == 'No' || e.rowData.status == null) {

      this.trnxCommonTs.checkingStatusSnackBar();

    } else {

      this.buttonName = this.constants.btnnameupdate;

      this.ngModelChildObject = this.trnxCommonTs.trnxEditIcon(this.ngModelChildObject, e.rowData);
      console.log(this.ngModelChildObject)
      this.ngModelChildObject.forEach(inputObject => {

        if (inputObject.imageName != null && inputObject.keyValue != null) {

          if ((inputObject.keyValue).length > 0) {

            let extension: any;

            if ((inputObject.keyValue).includes(".")) {

              extension = (inputObject.keyValue).substring((inputObject.keyValue).lastIndexOf(".") + 1);

              console.log(extension);

            }

            if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {

              this.binaryFormatImage(inputObject);

            }

          }

        }

      });

      console.log(e.rowData);

      console.log(this.ngModelChildObject);

      this.openForm("Update");

    }

  }

  openForm(buttonName) {
    console.log(this.listObjectDropDown)
    this.buttonName = buttonName;

    let width = "80%";

    if (this.bootstrapChildColumn == 1) {

      width = "55%";

    }

    let dialogRef = this.dialog.open(TrnxBasePopupScreenComponent, {
      maxWidth: '100vw',
      height: "95%",
      width: width,
      data: { ngModelObjectDivision: this.ngModelChildObjectDivision, ngModelObject: this.ngModelChildObject, tableName: this.tableName, dynamicData: this.dynamicChildData, retrieveObject: this.retrieveObject, buttonName: this.buttonName, listObjectDropDown: this.listObjectDropDown, bootstrapColumn: this.bootstrapChildColumn, tableID: this.childTableID, headerNameHtml: this.headerNameHtml, trnxScreenId: this.trnxScreenId, update: "childTrue" },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      // this.listObjectDropDown = result;

      this.retrieve();

    });

  }

  async binaryFormatImage(inputObject) {

    let response = await this.service.downloadImage(inputObject.keyValue)

    console.log(response);

    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([response]);

    console.log(newBlob);

    var reader: FileReader = new FileReader();

    reader.onloadend = e => {

      console.log(reader.result);

      inputObject.keyValue = reader.result.toString();

      inputObject.imageShow = true;

      inputObject.imageShow1 = true;

      inputObject.binaryFormat = true;

    };
    reader.readAsDataURL(newBlob);

  }

  // Aggrid Delete function
  async deleteIcon(e) {

    if (e.rowData.status == 'No' || e.rowData.status == null) {

      this.trnxCommonTs.checkingStatusSnackBar();

    }

    else {

      if (confirm(this.constants.confirmDeletion) == true) {

        let screenTypeTOrM = "TransactionChild";

        console.log(screenTypeTOrM);

        await this.trnxCommonTs.trnxDeleteIcon(e, this.tableName, this.ngModelChildObject, this.childTableID, screenTypeTOrM);

        await this.retrieve();

      }

    }

  }


  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalPages = this.gridAPI.paginationGetTotalPages()

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveChildTrnx(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelChildObject, this.recordsStart, this.childKey, this.tableId, this.trnxScreenId);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }

    //this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveChildTrnx(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelChildObject, this.recordsStart, this.childKey, this.tableId, this.trnxScreenId);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }

    //this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }



  cancel() {
    this.dialogref.close();
  }

  async retrieve() {
    console.log(this.childKey)
    console.log(this.ngModelChildObject)
    console.log(this.listObjectDropDown)
    this.retrieveObject = await this.trnxCommonTs.retrieveChildTrnx(this.tableName, this.listObjectDropDown, this.ngModelChildObject, this.recordsStart, this.childKey, this.tableId, this.trnxScreenId);

    console.log(this.retrieveObject);

    this.gridAPI.setGridOption('rowData', this.retrieveObject);

  }

  openSaveForm(buttonName) {

    console.log(this.listObjectDropDown)

    console.log(this.childKey);

    this.buttonName = buttonName;

    let width = "80%";

    if (this.bootstrapChildColumn == 1) {

      width = "55%";

    }

    //ChildKey is added, it has value of master table id of transaction table. Here tableId is name of transaction master table id.
    let dialogRef = this.dialog.open(TrnxBasePopupScreenComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: width,
      data: { ngModelObjectDivision: this.ngModelChildObjectDivision, ngModelObject: this.ngModelChildObject, tableName: this.tableName, dynamicData: this.dynamicChildData, retrieveObject: this.retrieveObject, buttonName: this.buttonName, listObjectDropDown: this.listObjectDropDown, bootstrapColumn: this.bootstrapChildColumn, tableID: this.childTableID, headerNameHtml: this.headerNameHtml, trnxScreenId: this.trnxScreenId, screenTypeTOrM: "TransactionChild", childKey: this.childKey, masterTableId: this.masterTableId },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      this.listObjectDropDown = result;
      console.log(this.listObjectDropDown);

      this.retrieve();

    });
  }

  formValidations() {

    this.formValid = this.trnxCommonTs.formValidations(this.dynamicData);

  }

  childDropDown(ngModelTemporary) {

    console.log(ngModelTemporary);
    console.log("++++++++++++++++++++++++++++");

    if (ngModelTemporary.dropDownChildFieldName != undefined && ngModelTemporary.keyValue != "" && ngModelTemporary.keyValue != undefined) {

      console.log(ngModelTemporary);

      let dropDownChildFieldName = ngModelTemporary.dropDownChildFieldName;

      let keyName = ngModelTemporary.keyName;
      console.log(keyName)

      let keyValue = ngModelTemporary.keyValue;
      console.log(keyValue)
      let childDropDownIndex: any = 0;

      this.ngModelObject.forEach(ngModelObjectTemp => {

        console.log(ngModelObjectTemp);

        if (dropDownChildFieldName == ngModelObjectTemp.keyName) {

          console.log(dropDownChildFieldName);

          console.log(ngModelObjectTemp.keyName);

          childDropDownIndex = ngModelObjectTemp.dropDownIndex;

          //When the popup is open ngmodelchange function will execute for that to stop keyValue empty
          if (this.buttonName == "Update" && this.childrenDropDownsIncrement < this.numberOfChildrenDropDowns) {

            this.childrenDropDownsIncrement++;

            console.log(this.childrenDropDownsIncrement);

          }

          else {

            ngModelObjectTemp.keyValue = "";

          }
        }

      });

      console.log(childDropDownIndex);

      console.log(this.tMLODD);

      let temporaryArray: any = [];

      this.tMLODD[childDropDownIndex].forEach(listObjectTemp => {
        console.log(keyValue)
        console.log(listObjectTemp)
        if (listObjectTemp[keyName] == keyValue) {

          temporaryArray.push(listObjectTemp);

        }

      });

      this.tMLOD[childDropDownIndex] = temporaryArray;

      console.log(this.tMLOD);

    }

    console.log(this.tMLOD);

  }

  //Insert or update data to the server.
  async updateData() {

    //Getting the username from localStorage.
    let userName = this.localStorageSettings.getSettings("AuthUsername");

    console.log(userName);

    //Getting the user record from users table using userName.
    let userObject: any = await this.service.retrieveSingleRecordService("users", "userName", userName);

    console.log(userObject);

    let isExecute: any = 0;

    isExecute = this.trnxCommonTs.checkingCombinationColumnsUnique(this.ngModelObject, this.retrieveObject, isExecute);

    console.log(isExecute);

    let tenantIDIndex: any;

    let approvedindex: any;

    let mmapprovalindex: any;

    let useridtemp: any;

    console.log(tenantIDIndex);

    console.log(this.ngModelObject)

     if (this.tableName?.toLowerCase() === 'testcycletrxn') {
        const cycleField = this.ngModelObject.find(
            (f: any) => f.keyName?.toLowerCase() === 'cyclename'
        );

        if (cycleField && typeof cycleField.keyValue === 'string' && cycleField.keyValue.trim() !== '') {
            const validPattern = /^[a-zA-Z0-9\s@#$\-_,.[\] ]+$/; // allowed characters
            if (!validPattern.test(cycleField.keyValue.trim())) {
                this.snackBar.open('Special characters are not allowed in Cycle Name.', 'Close', {
                    duration: 5000,
                    panelClass: ['error-snackbar']
                });
                this.spinner.stop(); 
                return; 
            }
        }
    }

    //Iterating ngModelObject object for storing value in tenantid.
    for (let i = 0; i < this.ngModelObject.length; i++) {

      //This condition will execute when keyName is equal to tenantid.
      if (this.ngModelObject[i].keyName == "tenantid") {

        console.log(this.ngModelObject[i].keyValue);

        //Storing tenantid index in tenantIDIndex.
        tenantIDIndex = i;

        console.log(tenantIDIndex);

      }

      if (this.ngModelObject[i].keyName == "approvedby") {
        if (this.ngModelObject[i].fieldType == "Checkbox") {
          console.log(this.ngModelObject[i].keyValue);
          useridtemp = i;
          if (this.ngModelObject[i].keyValue == true) {
            //Getting the tenantid from first json.
            console.log(useridtemp)
            let userIdValue = userObject[0].userid;

            console.log(userIdValue);

            //Storing the tenantid value in keyValue where keyName is tenantid.
            this.ngModelObject[i].keyValue = userIdValue;

            console.log(this.ngModelObject[i].keyValue);
          } else if (this.ngModelObject[i].keyValue == false) {
            this.ngModelObject[i].keyValue = "0";
          }
        }
      }
      if (this.ngModelObject[i].keyName == "approveddatetime") {

        console.log(this.ngModelObject[i].keyValue);

        approvedindex = i;

      }
      if (this.ngModelObject[i].keyName == "mmapproval") {

        mmapprovalindex = i;

      }

    }

    if (useridtemp != undefined) {
      console.log(useridtemp)
      if (this.ngModelObject[useridtemp].keyValue != 0) {
        const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
        let datetimevalue = moment(new Date(), DATE_TIME_FORMAT);

        //Storing the tenantid value in keyValue where keyName is tenantid.
        this.ngModelObject[approvedindex].keyValue = datetimevalue;
        this.ngModelObject[mmapprovalindex].keyValue = "Yes";
      } else {
        this.ngModelObject[approvedindex].keyValue = null;
        this.ngModelObject[mmapprovalindex].keyValue = "No";
      }

    }

    //It will execute when tenantid column is present.
    if (tenantIDIndex != undefined) {

      //Getting the tenantid from first json.
      let tenantIDValue = userObject[0].tenantid;

      console.log(tenantIDValue);

      //Storing the tenantid value in keyValue where keyName is tenantid.
      this.ngModelObject[tenantIDIndex].keyValue = tenantIDValue;

      console.log(this.ngModelObject[tenantIDIndex].keyValue);

    }

    let temporaryObject: any = [];

    temporaryObject = this.trnxCommonTs.ngModelData(this.ngModelObject);

    // checking the form is valid or not while update
    if (!this.formValid.valid) {
      console.log("djhdfhsf")
      // displaying validation messages
      this.validation.validateAllFormFields(this.formValid);

      this.validation.getvalidationmessage();

    }

    else {

      console.log("update");

      console.log(temporaryObject);

      console.log(this.tableName);

      console.log(isExecute);

      console.log(this.ngModelObject);

      console.log(this.tableID);

      await this.trnxCommonTs.updateTrnxData(temporaryObject, this.tMTN, isExecute, this.ngModelObject, this.tableID,"");

    }

  }

  changeStartEndDateValue(ngModelTemporary) {

    this.trnxCommonTs.changeStartEndDateValue(ngModelTemporary, this.ngModelObject);

  }

  changeStartEndDateTimeValue(ngModelTemporary) {

    this.trnxCommonTs.changeStartEndDateTimeValue(ngModelTemporary, this.ngModelObject);

  }

  getSanitizer(keyValue) {

    return this.sanitizer.bypassSecurityTrustUrl(keyValue);

  }

  //delete attachements
  deleteImage(ngModelTemporary) {

    this.trnxCommonTs.trnxDeleteImage(ngModelTemporary, this.formValid, this.ngModelObject);

  }

  openImage(image) {

    this.trnxCommonTs.openImage(image);

  }

  docdownload(ngModelTemporary) {

    console.log(ngModelTemporary);

    let imageName = "";

    this.ngModelObject.forEach(inputObject => {

      if (inputObject.keyName == ngModelTemporary.imageName) {

        imageName = inputObject.keyValue;

      }

    });

    console.log(imageName);

    this.service.download_test(ngModelTemporary.keyValue)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        console.log(data);

        var link = document.createElement('a');
        link.href = data;
        link.download = imageName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
  }

  // event on input type file
  imageFunction($event, ngModelTemporary): void {

    console.log($event);

    console.log(ngModelTemporary);

    this.readThisimage($event.target, ngModelTemporary);

  }

  // to encode the selected photo
  readThisimage(inputValue: any, ngModelTemporary): void {

    console.log(inputValue);

    console.log(ngModelTemporary);

    this.trnxCommonTs.readThisImage(inputValue, ngModelTemporary, this.ngModelObject, this.formValid);

  }

  radiochange(e) {
    console.log(e.value)

  }

}
